import * as React from "react";
import { SheetContent, cn } from "@eduviaos/ui-kit";
import { DESKTOP_MODAL_SHEET_CLASS, MOBILE_SHEET_CLASS } from "../lib/responsiveSheet";
import { useMdViewport } from "../lib/useMdViewport";

/**
 * Bottom sheet on phones; centred modal on md+ (768px).
 * Use for profile-adjacent flows, assessment reports, member lists, etc.
 */
export const ResponsiveSheetContent = React.forwardRef<
  React.ElementRef<typeof SheetContent>,
  React.ComponentPropsWithoutRef<typeof SheetContent>
>(function ResponsiveSheetContent({ className, ...props }, ref) {
  const isDesktop = useMdViewport();

  return (
    <SheetContent
      ref={ref}
      side={isDesktop ? "center" : "bottom"}
      className={cn(isDesktop ? DESKTOP_MODAL_SHEET_CLASS : MOBILE_SHEET_CLASS, className)}
      {...props}
    />
  );
});
